import script from "./FeatureListCategory.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeatureListCategory.vue?vue&type=script&setup=true&lang=ts"

import "./FeatureListCategory.vue?vue&type=style&index=0&id=07f3b001&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07f3b001"]])

export default __exports__